import { jsx as _jsx } from "react/jsx-runtime";
import { SupportChatMainDialog } from 'shared/support.chat/ui/main-dialog';
import { SupportIssues } from 'features/support.chat/ui/issue-list';
import { SupportChat } from 'entities/support.chat/ui';
import { MainHelpContent } from 'features/support.help/ui/main';
import { UiLearningList } from 'console/ui-guide/list';
import { BetaContent } from 'features/support.help/ui/beta';
export const support_routes = [
    {
        path: `/support`,
        element: _jsx(SupportChatMainDialog, {}),
        children: [
            {
                path: 'main',
                element: _jsx(MainHelpContent, {}),
            },
            {
                path: 'learning',
                element: _jsx(UiLearningList, {}),
            },
            {
                path: 'list',
                element: _jsx(SupportIssues, {}),
            },
            {
                path: 'issue/:ticket_id',
                element: _jsx(SupportChat, {}),
            },
            {
                path: 'beta',
                element: _jsx(BetaContent, {}),
            },
        ],
    },
];
